module.exports = __webpack_public_path__ + "static/media/logo-ipm2.4eca965d.png";